import { render, staticRenderFns } from "./schoolPhoto.vue?vue&type=template&id=2ac2d55c&"
import script from "./schoolPhoto.vue?vue&type=script&lang=js&"
export * from "./schoolPhoto.vue?vue&type=script&lang=js&"
import style0 from "./schoolPhoto.vue?vue&type=style&index=0&id=2ac2d55c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports